<nz-badge nzSize="small" [nzCount]="badgeCount" [nzOverflowCount]="9" [nzOffset]="[-5,5]">
  <button nz-button nzType="text" [routerLink]="routerLink">
    <span nz-icon nzType="mail" nzTheme="outline"></span>
  </button>
</nz-badge>
